import React, {useState} from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// ICONS
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function MarginsMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  let {margins, setMargins} = props;

  const open = Boolean(anchorEl);

  const handleClick = (value) => {
    let tempCopy = {...margins}
    tempCopy.top = value;
    tempCopy.bottom = value;
    tempCopy.left = value;
    tempCopy.right = value;
    setMargins(tempCopy)
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        variant="contained"
        disableElevation
        onClick={handleOpen}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        style={{backgroundColor: "#888", height: "100%"}}
      >
        Margins
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleClick(0)} disableRipple>
          0mm
          {margins.top === 0 ? <CheckIcon sx={{marginLeft: "10px"}}/> : ""}
        </MenuItem>
        <MenuItem onClick={() => handleClick(5)} disableRipple>
          5mm
          {margins.top === 5 ? <CheckIcon sx={{marginLeft: "10px"}}/> : ""}
        </MenuItem>
        <MenuItem onClick={() => handleClick(10)} disableRipple>
          10mm
          {margins.top === 10 ? <CheckIcon sx={{marginLeft: "10px"}}/> : ""}
        </MenuItem>
        <MenuItem onClick={() => handleClick(18)} disableRipple>
          18mm
          {margins.top === 18 ? <CheckIcon sx={{marginLeft: "10px"}}/> : ""}
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
